import { Skeleton } from "@mui/material";
import React from "react";
import { IoMdInformationCircleOutline } from "react-icons/io";

/**
 * DataStatsSection Component
 * 
 * Displays statistics summary section for datatable with title, tooltip, and stat cards.
 * Shows loading skeletons during data fetch. Maps statsArray to individual stat displays
 * with values from tableData.statistics or fallback totals.
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - Section title
 * @param {string} props.datatipText - Tooltip text for info icon
 * @param {Object} props.tableData - Table data with statistics
 * @param {Array} props.statsArray - Array of stat definitions with actualName and displayName
 * @param {boolean} props.isLoading - Loading state for skeleton display
 * @returns {JSX.Element} Statistics header section with stat cards
 */

const DataStatsSection = ({ props }) => {
  const { title, datatipText, tableData, statsArray, isLoading } = props;
  return (
    <div className="shutdowndataheaderdiv">
      <div className="shutdowndatatitlediv">
        <br />
        <span className="shutdowndatatext">
          {title}
          <sup data-tip={datatipText}>
            <IoMdInformationCircleOutline id="information-icon" />
          </sup>
        </span>
      </div>

      <div className="shutdowndatastatsdiv">
        {statsArray.map((statItem, index) =>
          isLoading ? (
            <div key={index}>
              <Skeleton
                className="tabledatatext"
                variant="rounded"
                width={210}
                height={16}
                style={{ marginBottom: "10px" }}
              />
              <Skeleton
                className="tabledatanumber"
                variant="rounded"
                width={210}
                height={22}
              />
            </div>
          ) : (
            <div key={index}>
              <div className="tabledatanumber">
                {tableData?.statistics?.[statItem.actualName] !== undefined
                  ? tableData.statistics[statItem.actualName]
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : statItem.total}
              </div>
              <span className="tabledatatext">{statItem.displayName}</span>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DataStatsSection;
